<template>
  <div v-if="show" class="d-flex flex-fill">
    <div v-if="mode === 'view'" class="d-flex flex-fill">
      <div class="fa fa-check" v-if="data === true"></div>
      <div class="fa fa-minus" v-else></div>
    </div>
    <div v-if="mode === 'edit' || mode === 'create'" class="d-flex flex-fill">
      <b-form-checkbox v-model="checked" name="check-button" @change="onValueChanged($event)" switch></b-form-checkbox>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ps-switch",
    props: {
      data: false,
      headerKey: null,
      mode: null
    },
    data() {
      return {
        show: true,
        checked: false,
      }
    },
    mounted() {
      this.checked = this.data;
    },
    methods: {
      onValueChanged(e) {
        this.$emit("dataChanged", this.headerKey, e);
      },
    },
    components: {},
    computed: {},

  };
</script>

<style scoped>

</style>
